import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class UserService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;

  getUsersList(pageNo: number, pageSize: number, filter: string, fUserName: string, fEmail: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(
        this.url + "management/user?pageNo=" + pageNo + "&pageSize=" + pageSize + "&filter=" + filter + "&userName=" + fUserName + "&email=" + fEmail
      ) .subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getUserById(id: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/user/" + id).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  saveUser(data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "management/user", data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  updateUser(id: number, data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.put(this.url + "management/user/" + id, data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getDownloadURL(): any {
    const authToken = sessionStorage.getItem("authToken");
    return this.url + "management/user/download?token=" + authToken;
  }

  downloadUsers(filter: string, fUserName: string, fEmail: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.download(this.url + "management/user/download/" + filter + "?userName=" + fUserName + "&email=" + fEmail).subscribe((result: any) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  activateOrInactivateUser(userId: any, status: boolean): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.put(this.url + "management/user/" + userId + "/activate/" + status, null).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  deleteUser(userId: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.delete(this.url + "management/user/" + userId + "/delete").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }



}